window.spinner_html = '<span class="sk-three-bounce"><span class="sk-child sk-bounce1"></span><span class="sk-child sk-bounce2"></span><span class="sk-child sk-bounce3"></span></span</span>';
